import _ from "lodash";
import { config } from "../constants/config";
import { getSearchLocations } from "./helpers";

function queryGlobalSearch({address, lang, searchField, types }) {
	const langQuery = lang ? `&lang=` + lang : `&lang=en`;

	return _.map(
		types ? types : getSearchLocations(),
		(t) =>
			`${address}/wp-json/wp/v2/search?subtype=${t}&per_page=${config.ITEMS_PER_GROUP}&search=${searchField}${langQuery}`
	);
}

export const endpoints = {
	globalSearch: queryGlobalSearch,
};
